import { Component, OnInit } from '@angular/core';
import { StockService } from 'src/app/services/stock/stock.service';
import { ExportStockService } from 'src/app/services/stock/export-stock.service';

@Component({
  selector: 'app-stock-en-route',
  templateUrl: './stock-en-route.component.html',
  styleUrls: ['./stock-en-route.component.css']
})
export class StockEnRouteComponent implements OnInit{
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  vehicles: any[] = [];
  searchText: string = '';
  public isInProgress: boolean = false;
  rowCount: number=0;

  constructor(
    private stockService:StockService,
    private exportStockService: ExportStockService
  ){}

  ngOnInit(): void {
    this.isInProgress=true;
    this.fetchStockEnroute();
  }

  fetchStockEnroute():void{
    this.stockService.getStockEnroute()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.rowCount = this.vehicles.length;
          this.isInProgress=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.rowCount =0;
           this.isInProgress=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
      }
    });
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

  exportToExcel(){
    this.isInProgress = true;
    this.exportStockService.exportStockEnroute()
  .subscribe({
      next: (response: Blob) => {
        this.isInProgress = false;
      
        // Create a download link for the file
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'STOCK-ENROUTE.xlsx'; // Set filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.successMessage = "Stock exported successfully!";
        this.errorMessage=null;
      },
      error: (error) => {
        this.isInProgress = false;
        this.errorMessage="Export failed. Please try again!";
        this.successMessage=null
        console.error("Download error:", error);
      }
    });
  }
}
